<div class="container p-4">
  <div class="container-text">
    <span class="title">{{ 'dialog_expiration.title' | translate }}</span>
    <span class="body"
      >{{ 'dialog_expiration.body' | translate }} {{ count }} {{ 'dialog_expiration.body2' | translate }}</span
    >
  </div>
  <br />
  <div class="container-buttons">
    <button mat-stroked-button color="primary" (click)="exit()" id="btn">Cerrar sesión</button>
    <button mat-raised-button color="primary" (click)="keep()" id="btn1">
      {{ 'dialog_expiration.buttons.keep_session' | translate }}
    </button>
  </div>
</div>
